let navigationLock = true;

export const lockNavigation = () => {
  navigationLock = true;
};

export const unlockNavigation = () => {
  navigationLock = false;
};

export const getNavigationLockState = () => navigationLock;

const globalUnloadHandler = e => {
  if (navigationLock) {
    e.preventDefault();
    e.returnValue = '';
  }

  navigationLock = true;
};

const toggleOneTrustCookiePreferences = () => {
  // target OneTrust script functionality to force display of modal
  return window?.OneTrust?.ToggleInfoDisplay();
};

export const globalClickHandler = ev => {
  if (ev.target.hasAttribute('data-no-warn')) {
    navigationLock = false;
  }

  // US441171 - CPRA Cookie Preference Footer Link
  // add global event listener to pop OneTrust cookie prefence modal
  // necessary due to re-rendered footer component losing click event from the DOM
  if (ev.target.id === 'oneTrustConsentPrefences') {
    toggleOneTrustCookiePreferences();
  }
};

export const attachNavigationLock = () => {
  window.addEventListener('beforeunload', globalUnloadHandler);
  window.addEventListener('click', globalClickHandler);
};

export const detachNavigationLock = () => {
  window.removeEventListener('beforeunload', globalUnloadHandler);
  window.removeEventListener('click', globalClickHandler);
};
